import { toTitleCase } from '@benzinga/utils';
import { ConfigSelectorOption, ConfigSelectorTab } from '../entities';

export const AllConfigsTab = (options: ConfigSelectorOption[], resourceName?: string): ConfigSelectorTab => ({
  displayText: `My ${toTitleCase(resourceName ?? 'config')}s`,
  getOptions: () => options.sort((a, b) => (a.favorite && b.favorite ? 0 : a.favorite ? -1 : 1)),
  id: 'all',
});
